import React from 'react';
import type { ViewProps } from 'react-native';
import { View, StyleSheet } from 'react-native';

export const MapWithControlsWrapper = (props: MapWithControlsWrapperProps) => {
  const { children, ...restProps } = props;

  return (
    <View style={styles.wrapper} {...restProps}>
      {children}
    </View>
  );
};

// ──────────────────────────────────────────────────────────────────────────────

type MapWithControlsWrapperProps = {
  readonly children: React.ReactNode;
} & ViewProps;

// ──────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    flex: 1,
  },
});
